import { render, staticRenderFns } from "./base-card-with-table.vue?vue&type=template&id=49356cb2&scoped=true"
import script from "./base-card-with-table.vue?vue&type=script&lang=js"
export * from "./base-card-with-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49356cb2",
  null
  
)

export default component.exports